import ApiService from "../common/apiService";
import TokenService from "../common/tokenService";
import {formatDate} from "../common/formatting";
import constants from "@/common/constants";
import {
  GET_PAST_NOTIFICATION,
  GET_USER_NOTIFICATION,
  SEND_NOTIFICATION,
  UPDATE_NOTIFICATION
} from "./actions.type";

const NotificationModule = {
  state: {
    errors: null,
    token: TokenService.getToken(),
    twoFactorAuth: {
      method: null,
      completed: null
    },
    latestNotifications:[],
    notifications:[],
    length: 0,
    total:0,
    admin:{
      notifications:[],
      currentNotifications:[],
      total:0,
      page:1,
      perPage:5
    }
  },
  mutations:{
    setUserNotification(state,data){
      let notify = data.notification;
      Object.entries(notify).forEach(([key, val]) => {
        val.date = formatDate(val.created_at);
        val.title = val.data.title;
        val.type = val.data.data.type;
      });
      state.notifications = notify;
      let unread = Object.keys(notify)
        .filter(key => notify[key].read_at == null)
        .reduce((obj,key) => {
          obj[key] = notify[key];
          return obj;
        },{});

      state.latestNotifications = unread;
      state.length = Object.keys(notify).length;
      state.total = data.count;
    },
    setPastNotifications(state,data){
      let notifications = data.map( notification => {
        let transformed = {};
        let log = JSON.parse(notification.log);

        transformed.id = notification.id;
        transformed.title = log.notificationTitle;
        transformed.body = log.notificationBody;
        transformed.date = notification.created_at;
        transformed.recipient = log.recipients;
        transformed.sender = notification.user.first_name + ' ' + notification.user.last_name;
        transformed.reminders = log.reminders?log.notificationSentTo == 'ALL_TA_USERS'?[]:log.reminders:[];
        return transformed;
      }).sort((a, b) => {
        return new Date(b.date) - new Date(a.date);
      });
      state.admin.notifications = notifications;
      state.admin.total = notifications.length;
    },
    setCurrentPastNotifications(state){
      let first = (state.admin.page-1) * state.admin.perPage;
      let last = state.admin.page * state.admin.perPage;
      state.admin.currentNotifications = state.admin.notifications.slice(first,last);
    },
    setPastNotificationsPage(state,page)
    {
      state.admin.page = page;
    },
    setPastNotificationsPerPage(state,perPage)
    {
      state.admin.perPage = perPage;
    }
  },
  getters: {

  },
  actions: {

    async [GET_USER_NOTIFICATION](context,payload){
      let currentCommittee = context.getters.getSelectedCommittee;
      let currentRole = localStorage.getItem(constants.CURRENT_ROLE);

      let res = {};
      let url = "/notifications?count="+payload+'&role='+currentRole;
      if('CM' === currentRole) {
        if(currentCommittee) {
          url = url +'&cmId='+currentCommittee;
        }else
          return {};
      }

      await ApiService.get(url)
        .then(response => {
          let items = response.data;
          res = items;
          context.commit('setUserNotification',items.data)
        })
        .catch(error => {
          res = error;
        })
      return res;
    },
    async [UPDATE_NOTIFICATION](context,payload){
      let res = {};
      let url = "/notifications/"+JSON.stringify(payload[0])+'?type='+payload[1];
      await ApiService.put(url)
        .then(response => {
          let items = response.data;
          res = items;
        })
        .catch(error => {
          res = error;
        })
      return res;
    },
    async [GET_PAST_NOTIFICATION](context,payload){
      let res = {};
      let url = "/notifications"+((payload == constants.TA_ADMIN_NOTIFICATION_UN_USED_TAS)? '?role=TA_ADMIN':'');
      await ApiService.get(url)
        .then(response => {
          let items = response.data;
          res = items;
          context.commit('setPastNotifications',items.data.logs);
          context.commit('setCurrentPastNotifications');
        })
        .catch(error => {
          res = error;
        })
      return res;
    },
    async [SEND_NOTIFICATION](context,payload){
      let res = {};
      let url = "/notifications";
      await ApiService.post(url,payload)
        .then(response => {
          let items = response.data;
          res = items;
        })
        .catch(error => {
          res = error;
        })
      return res;
    },
    updatePastNotificationsPage(context,page){
      context.commit('setPastNotificationsPage',page);
      context.commit('setCurrentPastNotifications');
    },
    updatePastNotificationsPerPage(context,perPage){
      context.commit('setPastNotificationsPerPage',perPage);
      context.commit('setCurrentPastNotifications');
    }
  }
};
export default NotificationModule;
